import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearAddRecordLoading,
    clearUpdateRecordError,
    clearUpdateRecordLoading,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    cancelAddRecord,
    cancelUpdateRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord,
    fetchListStart,
    fetchListSuccess,
    fetchListFail,
    clearList,
    clearAllLists,
    addToBottomOfList,
    updateInList,
    removeFromList,
} from "../utility";

const initialState = {
    lists: {},
    record: null,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_NOTE_LIST_START: return fetchListStart(state, action.payload);
        case actionTypes.FETCH_NOTE_LIST_SUCCESS: return fetchListSuccess(state, action.payload);
        case actionTypes.FETCH_NOTE_LIST_FAIL: return fetchListFail(state, action.payload);
        case actionTypes.CLEAR_NOTE_LIST: return clearList(state, action.payload);
        case actionTypes.CLEAR_NOTE_LISTS: return clearAllLists(state);
        case actionTypes.ADD_TO_NOTE_LIST: return addToBottomOfList(state, action.payload);
        case actionTypes.UPDATE_IN_NOTE_LIST: return updateInList(state, action.payload);
        case actionTypes.REMOVE_FROM_NOTE_LIST: return removeFromList(state, action.payload);
        case actionTypes.FETCH_NOTE_START: return fetchRecordStart(state);
        case actionTypes.FETCH_NOTE_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_NOTE_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_NOTE: return clearRecord(state);
        case actionTypes.ADD_NOTE_START: return addRecordStart(state);
        case actionTypes.ADD_NOTE_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_NOTE_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_NOTE_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_NOTE_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_NOTE_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_SINGLE_NOTE: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_NOTE_START: return updateRecordStart(state);
        case actionTypes.UPDATE_NOTE_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_NOTE_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_NOTE_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_NOTE_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_NOTE_CANCEL: return cancelUpdateRecord(state);
        default:
            return state;
    }
};

export default reducer;